import { render, staticRenderFns } from "./DetailDeviceLayout.vue?vue&type=template&id=225e9bf4&scoped=true&"
import script from "./DetailDeviceLayout.vue?vue&type=script&lang=js&"
export * from "./DetailDeviceLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetailDeviceLayout.vue?vue&type=style&index=0&id=225e9bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e9bf4",
  null
  
)

export default component.exports